var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.getCSSClass(),attrs:{"color":`${_vm.color} ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}`}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("head")],2)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("body")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }